<nb-layout>
  <nb-layout-header fixed>
  <h1>DASEC</h1>
  </nb-layout-header>

  <nb-sidebar>Dashboard</nb-sidebar>

  <nb-layout-column>


    <div class="row">

      <div class="col-6">
        <nb-card>
          <nb-card-header>Pie</nb-card-header>
          <nb-card-body>
            <ngx-chartjs-pie></ngx-chartjs-pie>
          </nb-card-body>
        </nb-card>
      </div>


    </div>


  </nb-layout-column>



</nb-layout>
